import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Grid,
  Paper,
  makeStyles,
  TextField,
  FormHelperText
} from '@material-ui/core';
import instance from 'api/globalaxios';
import UploadFileTdsat from './components/UploadFileTdsat';
import MainCaseDetails from './components/MainCaseDetails';
import { createReciepts, getPartyDetails } from './ApplicationFillingForm';
import SuccessScreenTdsat from './SuccessScreenTdsat';
import { RequiredLabel } from 'features/loginTdsat/Signup';
import DatePickerTDSAT from './components/DatePickerTDSAT';
import { CONFIG_FIELD_DATE, CONFIG_FIELD_INPUT_BASE } from './formConfigs';
import FormField from './FormField';
import PetitionerRespondentUI from './components/PetitionerRespondentUI';
import { submitFdrDepositDetails } from './API/TdsatApi';

const useStyles = makeStyles((theme) => ({
  form: {
    maxWidth: 600,
    margin: '0 auto',
    padding: theme.spacing(3),
  },
  title: {
    marginBottom: theme.spacing(10),
    marginTop: theme.spacing(2.5),
  },
  paper: {
    padding: theme.spacing(4),
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginBottom: theme.spacing(4),
  },
  button: {
    padding: theme.spacing(1),
    borderRadius: 12,
    fontSize: 22,
  },
  buttonPay: {
    padding: theme.spacing(1),
    borderRadius: 12,
    width: '50%',
    display: 'flex',
  },
  labelTitle: {
    display: 'flex',
    marginBottom: '8px',
    fontSize: '12px'
  },
  labelSubtitle: {
    display: 'flex',
    marginTop: '8px',
    fontSize: '11px',
    color: '#858D98',
    marginBottom: '32px'
  },
  amount: {
    fontSize: '18px',
  },
  titleCase: {
    color: '#000',
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: 700,
    display: 'flex'
  },
  nameTitle: {
    fontSize: '18px',
    lineHeight: '31.32px',
    fontWeight: 400,
    display: 'flex'
  },
  containerCaseInfo: {
    marginBottom: '18px'
  },
  userInfo: {
    display: 'flex',
    flexDirection: 'column'
  },
  containerUser: {
    marginTop: '18px'
  },
  titleUserInfo: {
    display: 'flex',
    color: '#000',
    fontSize: '16px'
  },
  partyName: {
    fontSize: '18px',
    fontWeight: '400'
  },
  submitButton: {
    display: 'flex',
    justifyContent: 'center'
  }
}));

const FDRDepositDetails = ({draftCase}) => {
  const classes = useStyles();

  const [formData, setFormData] = useState({
    case_number: draftCase ? draftCase?.main_case?.case_number?.split('/')[1] : '',
    year: draftCase ? draftCase?.year : '',
    type_of_deposit: '',
    claimant_parties: [],
    respondent_parties: [],
    amount: "",
    is_draft: true,
    main_case: draftCase ? draftCase?.main_case : '',
    selectType: draftCase ? draftCase?.main_case?.case_number ? 'caseNumber' : 'diaryNumber' : 'caseNumber',
    diary_number: draftCase ? draftCase?.main_case?.diary_number?.split('/')[0] : '',
    case_type: draftCase ? draftCase?.main_case?.case_number?.split('/')[0] : '',
    order_date: new Date(),
    name_of: '',
    FDR_number: '',
    FDR_date: new Date(),
    bank_details: '',
    other_deposit: '',
  });

  const [errors, setErrors] = useState({});

  const [partyDetails, setPartyDetails] = useState([]);
  const [depositDetailsResponse, setDepositDetailsResponse] = useState({});
  const [isSuccess, setIsSuccess] = useState(false);
  const [diaryNumber, setDiaryNumber] = useState(null);
  const [draftDate, setDraftDate] = useState(null);

  useEffect(()=>{
    if(draftCase){
      setDepositDetailsResponse(draftCase);
      handleClaimantRespondentData(formData);
    }
  },[])

  const handleInputChange = (name, value) => {
    // const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }; 

  const handleInputChangeMainCase = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }; 

  const handleOrderDateInput = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      'order_date': value,
    }));
  }

  const handleDateInput = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      'FDR_date': value,
    }));
  }

  const validateForm = () => {
    let tempErrors = {};
    if (!formData?.type_of_deposit) tempErrors.type_of_deposit = 'This field is required';
    if (!formData?.order_date) tempErrors.order_date = 'This field is required';
    if (!formData?.name_of) tempErrors.name_of = 'This field is required';
    if (!formData?.FDR_number) tempErrors.FDR_number = 'This field is required';
    if (!formData?.bank_details) tempErrors.bank_details = 'This field is required';
    if (!formData?.amount) tempErrors.amount = 'This field is required';
    if (!formData?.FDR_date) tempErrors.FDR_date = 'This field is required';
    if ((formData?.type_of_deposit === 'Other') && !formData?.other_deposit) tempErrors.other_deposit = 'This field is required';
    if (formData?.claimant_parties?.length === 0 && formData?.respondent_parties?.length === 0) {
      tempErrors.claimant_parties = 'At least one Party is required';
    } else if ((formData?.claimant_parties?.length > 0 && formData?.respondent_parties?.length > 0) || formData?.claimant_parties?.length > 1 || formData?.respondent_parties?.length > 1) {
        tempErrors.claimant_parties = 'Only one Party can be selected ';
    }
    if (!formData.agree) tempErrors.agree = 'You must agree before submitting';

    return tempErrors;
  };

  const createApplication = async () => {
    const identifier = formData.case_number 
    ? { case_number: formData.case_number, year: formData.year, case_type: formData?.case_type }
    : { diary_number: formData.diary_number, year: formData.year };
    try{
      const response = await instance.post(`/tdsat/courtfees/`, identifier)
      setDepositDetailsResponse(response?.data)
      setFormData((prevData) => ({
        ...prevData,
        main_case: response?.data?.main_case,
      }));
    }catch(error){
      console.error("There was an error fetching the case data!", error);
    }
  }

  const handleClaimantRespondentData = async (formData) => {
    let url = '';
    if (formData?.case_number) {
      url = `/tdsat/api/maincaseretrieve/?case_number=${formData.case_number}&year=${formData.year}&case_type=${formData?.case_type}`;
    } else if (formData?.diary_number) {
      url = `/tdsat/api/maincaseretrieve/?diary_number=${formData.diary_number}&year=${formData.year}`;
    } else {
      throw new Error('Please provide either a case number or a diary number.');
    }
    try {
      const response = await instance.get(url)
      const { claimant_parties, respondent_parties } = response.data;
      const allParties = [...claimant_parties, ...respondent_parties];
      if (allParties.length > 0) {
        const partyDetailsResponse = await getPartyDetails(allParties);
        setPartyDetails(partyDetailsResponse);  
        // const caseTypes = await getCaseTypes('CourtFees');   
        // setCourtFeesTypes(caseTypes);
        if(!draftCase){
          createApplication();
        }
      }
    } catch (error) {
      alert('No Main Case found')
      console.error("There was an error fetching the case data!", error);
    }
  };

  const handleSubmitFDRDepositDetails = async (formData) => {
    const formErrors = validateForm();
    if (Object.keys(formErrors).length === 0) {
      const updatedFormData = { 
        ...formData, 
        'order_date': formData?.order_date,
        'dd_or_fdr_no': formData?.FDR_number,
        'dd_or_fdr_date': formData?.FDR_date,
        'bank_and_branch_details': formData?.bank_details,
        'type_of_deposit': formData?.type_of_deposit === 'Other' ? formData?.other_deposit : formData?.type_of_deposit,
        'in_the_name_of': formData?.name_of,
        'dd_or_fdr_amount': formData?.amount,
        is_draft: false 
      };
      try{
        submitFdrDepositDetails(depositDetailsResponse?.id, updatedFormData).then(async (response)=> {
          createReciepts({content_type: 'courtfees', receipt_number: formData?.FDR_number, object_id: response?.data?.id});
          setDraftDate(response?.data?.case_creation_date_time)
          setIsSuccess(true)
        }).catch((error) => {
          console.log(error, 'recieptErorr');
        })
      }catch(error){
        console.error("There was an error fetching the case data!", error);
      }
    }else {
      setErrors(formErrors);
    }
  }

  const depositTypes = ['FDR', 'Cost', 'Other'];

  const FRDConfig = {
    title: 'FDR',
    sections: {
      fields: [
        { type: CONFIG_FIELD_INPUT_BASE, label: "In the name of",keyId: 'name_of', required: true },
        { type: CONFIG_FIELD_INPUT_BASE, label: 'DD/FDR number', keyId: 'FDR_number',required: true },
        { type: CONFIG_FIELD_DATE, label: 'DD/FDR Date',keyId: 'FDR_date',required: true },
        { type: CONFIG_FIELD_INPUT_BASE, label: 'DD/FDR amount', keyId: 'amount',required: true },
        { type: CONFIG_FIELD_INPUT_BASE, label: 'Bank and Branch Details', multiline: true, keyId: 'bank_details', required: true },
      ]
    }   
  };

  const CostConfig = {
    title: 'Cost/Others',
    sections: {
      fields: [
        { type: CONFIG_FIELD_INPUT_BASE, label: "In the name of",keyId: 'name_of', required: true },
        { type: CONFIG_FIELD_INPUT_BASE, label: 'DD number', keyId: 'FDR_number',required: true },
        { type: CONFIG_FIELD_DATE, label: 'DD Date',keyId: 'FDR_date',required: true },
        { type: CONFIG_FIELD_INPUT_BASE, label: 'DD amount', keyId: 'amount',required: true },
        { type: CONFIG_FIELD_INPUT_BASE, label: 'Bank and Branch Details', multiline: true, keyId: 'bank_details', required: true },
      ]
    }   
  };

  const updateFormData =  (keyId, value) => {
    setFormData(prevState => ({
        ...prevState,
        [keyId]: value
    }));
  }
  
  
  return (
    <>
      {isSuccess ? 
        <SuccessScreenTdsat diaryNumber={diaryNumber} date={draftDate}/>
        :
      <Box component="form" className={classes.form}>
        <Typography variant="h4" align="center" className={classes.title}>
          FDR/Cost Deposit Details
        </Typography>
        <MainCaseDetails
          classes={classes}
          formData={formData}
          handleInputChange={handleInputChangeMainCase}
          handleClaimantRespondentData={handleClaimantRespondentData}
          partyDetails={partyDetails}
        />
        {partyDetails?.length > 0 && (
          <>
            <Paper className={classes.paper}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl fullWidth margin="none" variant="outlined" style={{textAlign:'left'}}>
                    <RequiredLabel className={classes.label} label={'Order Date'} />
                    <DatePickerTDSAT
                      FDR_date={formData.order_date}
                      setDate={handleOrderDateInput}
                      isRequired={true}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  {partyDetails?.length > 0 && 
                    <PetitionerRespondentUI 
                      data={partyDetails}
                      handleInputChange={handleInputChange}
                      formData={formData}
                      setFormData={setFormData}
                      classes={classes}
                      errors={errors}
                    />
                  }
                </Grid>
                <Grid item xs={12}>
                  <FormControl required fullWidth margin="none" variant="outlined">
                    <InputLabel>{'Type of Deposit'}</InputLabel>
                    <Select
                      label={'Type of Deposit'}
                      name="type_of_deposit"
                      value={formData?.type_of_deposit}
                      onChange={handleInputChangeMainCase}
                    >
                      {depositTypes?.map((type, index) => (
                        <MenuItem key={index} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.type_of_deposit && <FormHelperText style={{color: 'red'}}>{errors.type_of_deposit}</FormHelperText>}
                  </FormControl>
                </Grid>
                {formData?.type_of_deposit === 'Other' && (
                  <>
                    <Grid item xs={12}>
                      <TextField
                        variant='outlined'
                        label='Enter other type of deposit'
                        required
                        fullWidth
                        name='other_deposit'
                        onChange={handleInputChangeMainCase}
                      />
                      {errors.other_deposit && <FormHelperText style={{color: 'red'}}>{errors.other_deposit}</FormHelperText>}
                    </Grid>
                  </>
                )}
                {formData?.type_of_deposit && (
                  formData?.type_of_deposit === 'FDR' ? (
                    FRDConfig?.sections.fields.map((field, index) => (
                      <Grid item xs={12} key={index} style={{display: 'flex', justifyContent: 'flex-start'}}>
                        <FormField 
                          field={field} 
                          value={formData[field.keyId] || ''} 
                          onChange={field?.keyId === 'FDR_date' ? handleDateInput : handleInputChange}  
                          error={errors[field.keyId]}
                        />
                      </Grid>
                    ))
                  ) : (
                    CostConfig?.sections.fields.map((field, index) => (
                      <Grid item xs={12} key={index} style={{display: 'flex', justifyContent: 'flex-start'}}>
                        <FormField 
                          field={field} 
                          value={formData[field.keyId] || ''} 
                          onChange={field?.keyId === 'FDR_date' ? handleDateInput : handleInputChange}  
                          error={errors[field.keyId]}
                        />
                      </Grid>
                    ))
                  )
                )}
              </Grid>
            </Paper>
            <UploadFileTdsat
              classes={classes} 
              formData={formData}
              handleInputChange={handleInputChange}
              setFormData={updateFormData}
              applicationResponse={depositDetailsResponse}
              uploadType={'CourtFees'}
              errors={errors}
            />
            <Grid className={classes.submitButton}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonPay}
                onClick={()=>handleSubmitFDRDepositDetails(formData)}
                errors={errors}
              >
                Submit 
              </Button>
            </Grid>
          </>
        )}
      </Box>
      }
    </>
  );
};

export default FDRDepositDetails;
